/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_Gsm_Existing_HintInputs */

const cs_sreality_seller_gsm_existing_hint = /** @type {(inputs: Sreality_Seller_Gsm_Existing_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`listSeller mobil nevrací. Použijeme veřejný telefon uživatele, pokud je vyplněný; jinak zadejte mobil z admin.sreality.cz.`)
};

const en_sreality_seller_gsm_existing_hint = /** @type {(inputs: Sreality_Seller_Gsm_Existing_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`listSeller does not return mobile. We use the user’s public phone when set; otherwise enter the mobil from admin.sreality.cz.`)
};

/**
* | output |
* | --- |
* | "listSeller does not return mobile. We use the user’s public phone when set; otherwise enter the mobil from admin.sreality.cz." |
*
* @param {Sreality_Seller_Gsm_Existing_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_gsm_existing_hint = /** @type {((inputs?: Sreality_Seller_Gsm_Existing_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_Gsm_Existing_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_gsm_existing_hint(inputs)
	return cs_sreality_seller_gsm_existing_hint(inputs)
});